import { PrimaryPanelsSlotPlacement as BasicPrimaryPanelsSlotPlacement } from '@wix/extensions-slots-host';
import { withEditorSlotsState } from '../withEditorSlotsState';

export const PrimaryPanelsSlotPlacement = withEditorSlotsState(
  BasicPrimaryPanelsSlotPlacement,
);
